import { render, staticRenderFns } from "./AvatarUserMenu.vue?vue&type=template&id=74acf562&"
import script from "./AvatarUserMenu.vue?vue&type=script&setup=true&lang=js&"
export * from "./AvatarUserMenu.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports